/**
 * Value stored in the obsolescence status fields when no status is known. These fields
 * are never stored as "" or null: an import file without the column, an import file with
 * an empty cell and the create modals all save this value instead.
 * "" stays part of ObsolescenceStatus for the documents written before this rule.
 */
export const WITHOUT_DATA = "withoutData";

/**
 * Obsolescence Status
 */
export type ObsolescenceStatus =
  | ""
  | "withoutData"
  | "unconfirmed"
  | "active"
  | "obsolete"
  | "nrnd"
  | "resolved"
  | "PDN issued";

export type ObsolescenceStatusForecast =
  | ""
  | "active"
  | "obsolete"
  | "unconfirmed";

/**
 * Risk Assessment
 */
export type ObsolescencelifeCycleRisk =
  | ""
  | "low"
  | "medium"
  | "high"
  | "unknown";

/**
 * EuRoHS
 */
export type EuRoHSStatus =
  | ""
  | "yes"
  | "yes with exemption"
  | "no"
  | "not required"
  | "unknown";

/**
 * Reach Affected
 */
export type ReachAffectedStatus = "" | "yes" | "no" | "unknown";
